import {
  MEMBERSHIPS_REQUEST_APPROVAL,
  MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS,
  MEMBERSHIPS_REQUEST_APPROVAL_ERROR,
  MEMBERSHIPS_REQUEST_APPROVAL_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const MembershipsRequestApproval = (state = initialState, action) => {
  switch (action.type) {
    case MEMBERSHIPS_REQUEST_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case MEMBERSHIPS_REQUEST_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case MEMBERSHIPS_REQUEST_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case MEMBERSHIPS_REQUEST_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default MembershipsRequestApproval;
